import styles from './lineBreak.module.scss'

const LineBreak = () => (
    <div className={styles.lineBreak}></div>
)

export default LineBreak